import React from 'react';

const WorkInProgress = ({ 
  title = "Under Construction", 
  message = "We're currently enhancing this feature to deliver the best possible experience. Our engineering team is implementing advanced functionality and conducting thorough quality assurance testing.", 
  showGear = true 
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-64 p-8 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-lg border border-blue-200">
      {/* Animated SVG Icon */}
      <div className="mb-6">
        <svg 
          width="120" 
          height="120" 
          viewBox="0 0 120 120" 
          className="drop-shadow-md"
        >
          {/* Background Circle */}
          <circle 
            cx="60" 
            cy="60" 
            r="50" 
            fill="#3B82F6" 
            opacity="0.1"
            className="animate-pulse"
          />
          
          {/* Main Gear */}
          <g className="animate-spin origin-center" style={{ animationDuration: '3s' }}>
            <circle cx="60" cy="60" r="25" fill="#3B82F6" />
            <circle cx="60" cy="60" r="15" fill="white" />
            {/* Gear Teeth */}
            {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, index) => (
              <rect
                key={index}
                x="58"
                y="32"
                width="4"
                height="8"
                fill="#3B82F6"
                transform={`rotate(${angle} 60 60)`}
              />
            ))}
          </g>
          
          {/* Secondary Gear */}
          <g className="animate-spin origin-center" style={{ animationDuration: '2s', animationDirection: 'reverse' }}>
            <circle cx="85" cy="35" r="15" fill="#6366F1" />
            <circle cx="85" cy="35" r="8" fill="white" />
            {/* Small Gear Teeth */}
            {[0, 60, 120, 180, 240, 300].map((angle, index) => (
              <rect
                key={index}
                x="84"
                y="18"
                width="2"
                height="5"
                fill="#6366F1"
                transform={`rotate(${angle} 85 35)`}
              />
            ))}
          </g>
          
          {/* Progress Dots */}
          <g className="animate-pulse">
            <circle cx="30" cy="90" r="3" fill="#3B82F6" opacity="0.6" />
            <circle cx="45" cy="95" r="3" fill="#3B82F6" opacity="0.4" />
            <circle cx="60" cy="98" r="3" fill="#3B82F6" opacity="0.8" />
            <circle cx="75" cy="95" r="3" fill="#3B82F6" opacity="0.3" />
            <circle cx="90" cy="90" r="3" fill="#3B82F6" opacity="0.7" />
          </g>
          
          {/* Animated Progress Bar */}
          <rect x="20" y="100" width="80" height="4" fill="#E5E7EB" rx="2" />
          <rect x="20" y="100" width="50" height="4" fill="#3B82F6" rx="2">
            <animate
              attributeName="width"
              values="20;60;35;80;20"
              dur="4s"
              repeatCount="indefinite"
            />
          </rect>
        </svg>
      </div>
      
      {/* Content */}
      <div className="text-center space-y-3">
        <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
        <p className="text-gray-600 max-w-md leading-relaxed">{message}</p>
        
        {/* Status Indicator */}
        <div className="flex items-center justify-center space-x-2 mt-4">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <span className="text-sm text-gray-500 font-medium">Engineering in Progress</span>
        </div>
      </div>
      
      {/* Optional Loading Spinner */}
      <div className="mt-6 flex space-x-1">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
            style={{ animationDelay: `${i * 0.2}s` }}
          ></div>
        ))}
      </div>
    </div>
  );
};

// Example usage - now showing just one component
const App = () => {
  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      <WorkInProgress />
    </div>
  );
};

export default App;